import './ScrollingArticles.scss'

import { useEffect, useState } from 'react'
import ArticleCard from 'components/articles/ArticleCard'

// Initialize the intersection observer
const _previewObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    // Default to a blank image
    let imageSrc = ''

    // Show the thumbnail preview
    if (entry.isIntersecting)
      imageSrc = entry.target.getAttribute('data-preview-src') || imageSrc

    // Update the image src
    entry.target.style.backgroundImage = `url('${imageSrc}')`
  })
})

/**
 * ScrollingArticles component. Used to display horizontally scrolling article card component
 */
export default function ScrollingArticles({
  title,
  articles,
  returnPath = null,
  emptyText = 'Nothing here yet'
}) {
  const [cards, setCards] = useState()

  useEffect(() => {
    setCards(articles)
  }, [articles])

  return (
    <>
      {title && <h3>{title}</h3>}
      <div className='scrolling-articles-wrapper'>
        <div className='scrolling-card-cards'>
          {cards && cards.length > 0 ? (
            cards.map(
              (article, i) =>
                article && (
                  <ArticleCard
                    key={article._id}
                    article={article}
                    style={{ animationDelay: `${0.05 * i}s` }}
                    returnPath={returnPath}
                    observer={_previewObserver}
                  />
                )
            )
          ) : (
            <div className='no-cards'>
              <p>{emptyText}</p>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
